/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { FaEdit, FaKey, FaLockOpen } from "react-icons/fa";
import { formatDate } from "date-fns";
import FilterBarV2 from "components/users/filter-bar";
import Loader from "components/PageLoader";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";

import {
  useExportUsers,
  useGetUsersListPaginated,
  useUnlockUser,
} from "../../services/auth-api";
import PasswordResetModal from "../../components/users/passwordResetModal";
import { HasPermission } from "../../utils/helper";
import { initialDataState } from "./constants";
import BreadCrumb from "components/breadCrumb";

export default function UsersFollowUp() {
  const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const user = useUser();
  const [dataState, setDataState] = useState(initialDataState);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 25;
  const [filters, setFilters] = useState({
    searchCriteria: "",
    selectedCashCenterId: "",
  });
  const {
    mutate: getUserList,
    isSuccess: userListAvailable,
    data: usersList,
    isPending: gettingUsersList,
    // error: userListError,
    reset: resetUsersList,
  } = useGetUsersListPaginated();
  const {
    mutate: exportUsers,
    data: exportedUsers,
    isPending: exportingUsers,
    // error: userListError,
    reset: resetExportUsers,
  } = useExportUsers();
  const {
    mutate: unlockAccount,
    // isSuccess: accountUnlocked,
  } = useUnlockUser();

  useEffect(() => {
    if (userListAvailable && usersList) {
      const _usersList = usersList.data.data;

      setUsers(_usersList);

      setTotalRecords(usersList.data.totalRecords);
      setUsers(_usersList);
      resetUsersList();
    }

    if (exportedUsers) {
      setAllUsers(exportedUsers.data.data);
      resetExportUsers();
    }
  }, [userListAvailable, exportedUsers]);

  useEffect(() => {
    setCurrentPage(1);
    getUserList({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: formatDate(new Date(), "yyyy-MM-dd'T'00:00:00.000'Z'"),
      cashCenterId: filters.selectedCashCenterId || "",
    });
  }, [filters]);

  const passwordResetCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Reset Password"
          onClick={() => {
            setShowPasswordResetModal(true);
            setSelectedUser(dataItem);
          }}
        >
          <FaKey fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };
  const unlockAccountCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Unlock Account"
          onClick={() => {
            unlockAccount({ email: dataItem.email, userId: dataItem.userId });
          }}
        >
          <FaLockOpen fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const viewUserCell = ({ dataItem }) => {
    return (
      <td>
        {canViewDetails ? (
          <Link
            to={`${Paths.userDetails}/${dataItem.userId}`}
            style={{ color: "blue" }}
          >
            {dataItem.userName}
          </Link>
        ) : (
          <> {dataItem.userName}</>
        )}
      </td>
    );
  };

  const editUserCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          as={Link}
          to={`${Paths.editUser}/${dataItem.userId}`}
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Edit"
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  // const deleteUserCell = () => {
  //   return (
  //     <td>
  //       <Flex
  //         justifyContent="center"
  //         w="100%"
  //         title="Reset Password"
  //         cursor="pointer"
  //       >
  //         <MdDeleteSweep fontSize="18px" color="var(--primary-dark)" />
  //       </Flex>
  //     </td>
  //   );
  // };

  const onModalClose = () => {
    setShowPasswordResetModal(false);
    setSelectedUser(null);
  };
  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getUserList({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
      cashCenterId: filters.selectedCashCenterId || "",
    });
  };

  const canEdit = useMemo(() => {
    return HasPermission(user, "User", "Edit");
  }, [user]);
  const canViewDetails = useMemo(() => {
    return HasPermission(user, "User", "View");
  }, [user]);
  const canResetPassword = useMemo(() => {
    return HasPermission(user, "User", "ResetPassword");
  }, [user]);
  // const canDelete = useMemo(() => {
  //   return HasPermission(user, "User", "Delete");
  // }, [user]);
  return (
    <Flex className="main-container">
      {gettingUsersList || exportingUsers ? <Loader /> : <></>}
      {showPasswordResetModal ? (
        <PasswordResetModal
          show={showPasswordResetModal}
          onClose={onModalClose}
          user={selectedUser || {}}
        />
      ) : (
        <></>
      )}
      <Flex px="20px">
        <BreadCrumb
          links={[
            { text: "Dashboard", link: Paths.dashboard },
            { text: "Users", isCurrentPage: true },
          ]}
        />
      </Flex>
      <Card m="20px">
        <CardBody>
          <FilterBarV2
            getList={(filter, cashCenterId) => {
              setFilters({
                searchCriteria: filter,
                selectedCashCenterId: cashCenterId,
              });
            }}
          />

          <Grid
            data={process(users || [], { ...dataState, skip: 0 })}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            filterable
            sortable
            pageable
            className="user-list-grid"
          >
            <Column
              field="employeeId"
              title="Employee Id"
              width={120}
              className="text-center"
              headerClassName="text-center"
            />
            <Column
              field="userName"
              title="User Name"
              className="text-center"
              headerClassName="text-center"
              width={120}
              cell={viewUserCell}
            />
            <Column field="name" title="Name" />
            <Column field="email" title="Email" width={170} />
            {/* <Column field="personalEmail" title="Alternate Email" width={140} /> */}
            <Column field="mobileNo" title="Mobile No" width={120} />
            {/* <Column field="mobileNo" title="Alternate Mobile No" width={150} /> */}
            <Column field="designation" title="Designation" width={120} />
            <Column
              field="assignment"
              title="Assignment"
              width={120}
              className="text-center"
              headerClassName="text-center"
            />
            <Column field="nationality" title="Nationality" width={120} />
            <Column
              field="accountType"
              title="Account Type"
              width={130}
              className="text-center"
            />
            <Column
              field="status"
              title="Account Status"
              className="text-center"
              width={150}
              headerClassName="text-center"
            />

            {canEdit ? (
              <Column
                field="status"
                title="Edit"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={editUserCell}
                filterable={false}
                sortable={false}
              />
            ) : (
              <></>
            )}
            {canResetPassword ? (
              <Column
                filterable={false}
                title="Reset Password"
                headerClassName="text-center"
                className="text-center"
                width={120}
                cell={passwordResetCell}
              />
            ) : (
              <></>
            )}
            <Column
              filterable={false}
              title="Unlock Account"
              headerClassName="text-center"
              className="text-center"
              width={120}
              cell={unlockAccountCell}
            />

            {/* {canDelete && false ? (
              <Column
                field="status"
                title="Delete"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={deleteUserCell}
              />
            ) : (
              <></>
            )} */}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
